/**
 * Custom MLP Headers set in origin-request Lambda Edge
 */
export const mlpCustomHeaders = {
  LOCALE: 'x-eb-locale',
  EB_SERVER: 'x-eb-server',
};

/**
 * Custom MLP Header values for origin-response Lambda Edge
 */
export const mlpCustomHeaderValues = {
  MLP_WEBAPP: 'mlp-webapp',
  CACHE_ME: 'cacheme',
};
